import React, { useEffect, useState, } from "react";
import { useAuth } from "../Provider/AuthProvider";
import { Toast, ToastHeader, ToastBody } from "reactstrap";
import { useNavigate } from "react-router-dom";

interface ProtectedRouteProps {
    component: React.ReactNode;
    requiredInterface?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ component, requiredInterface }) => {
    const { allowedInterfaces, interfacesLoaded } = useAuth();
    const [showToast, setShowToast] = useState(false);
    const navigate = useNavigate();

    const hasAccess = !requiredInterface || allowedInterfaces.includes(requiredInterface);

    useEffect(() => {
        if (interfacesLoaded && !hasAccess) {
            setShowToast(true);
            if (allowedInterfaces.length > 0)
                navigate("/" + allowedInterfaces[0]);

        }
    }, [interfacesLoaded, hasAccess]);

    useEffect(() => {
        let timer: ReturnType<typeof setTimeout>;
        if (showToast) {
            timer = setTimeout(() => {
                setShowToast(false);
            }, 5000); // 5000ms = 5s
        }
        return () => {
            if (timer) clearTimeout(timer);
        };
    }, [showToast]);

    if (!interfacesLoaded) return null;

    return (
        <>
            {showToast && (
                <div style={{ position: "fixed", top: "1rem", right: "1rem", zIndex: 2000 }}>
                    <Toast isOpen={showToast}>
                        <ToastHeader toggle={() => setShowToast(false)} icon="danger">
                            Accès refusé
                        </ToastHeader>
                        <ToastBody>
                            ⛔ Vous n’avez pas la permission requise pour cette page.
                        </ToastBody>
                    </Toast>
                </div>
            )}

            {hasAccess && <>{component}</>}
        </>
    );
};

export default ProtectedRoute;
